/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToothChartSelector/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function ToothChartSelector({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/ToothChart/Content/ToothChartSelector"
  
}) {
let toothChartSnapshotsValueData = fromData.useDataFormat({ viewPath,
context: 'tooth_chart_snapshots',
format: fromHelpers.asList,
})
let tabToothChartSnapshotIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tooth_chart_snapshot_id',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 maxWidth={220}
 size="small"
 data="tooth_chart_snapshots"
 format="helpers.js asList"
 from={toothChartSnapshotsValueData}
 data="tab.tooth_chart_snapshot_id"
 value={tabToothChartSnapshotIdValueData}
 onChange={onChange}
 flexDirection="row"
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
 backgroundColor="transparent"
 borderColor={dtColorsNeutral400}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}